module.exports = __webpack_public_path__ + "static/img/ae.cf878578.svg";